/*@flow*/
import L from 'leaflet';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

export const defaultOptions = {
  color: 'red',
  weight: 1,
  opacity: 0.3,
  fillOpacity: 0.3,
  fillColor: 'red',
  fill: false,
  stroke: true,
  interactive: false,
};

type OptionsT = {|
  latlon: number[] | Leaflet$LatLng,
  opacity?: number,
  fillOpacity?: number,
  weight?: number,
  radius?: number,
  color?: string,
  fillColor?: string,
|};

export default (props: DeckPropsT<OptionsT>) => {
  const [element, setElement] = useState();
  const { options } = props;

  useEffect(() => {
    const { latlon, ...rest } = options;
    let newOptions = { ...defaultOptions, ...rest };
    const el: Leaflet$Circle = L.circle(latlon, newOptions);
    setElement(() => el);
  }, []);

  useLayer<OptionsT>(props, element);

  useEffect(() => {
    if (!element) return;
    let { latlon } = options;
    latlon && element.setLatLng(latlon);
  }, [options, element]);
};
